import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

const AVATAR_SIZE = 28;

export function getPickStatsMemberPicksRowStyles(C: WcColors) {
  return StyleSheet.create({
    memberPicksScroll: {
      marginTop: 0,
    },
    memberPicksContent: {
      paddingHorizontal: 16,
      paddingBottom: 4,
      gap: 8,
    },
    memberPickCard: {
      width: 78,
      borderRadius: 12,
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
      padding: 10,
      paddingHorizontal: 8,
      alignItems: 'center',
      gap: 6,
    },
    memberPickCardMe: {
      borderColor: C.purple + '88',
    },
    memberPickAvatar: {
      width: AVATAR_SIZE,
      height: AVATAR_SIZE,
      borderRadius: AVATAR_SIZE / 2,
    },
    memberPickAvatarFallback: {
      width: AVATAR_SIZE,
      height: AVATAR_SIZE,
      borderRadius: AVATAR_SIZE / 2,
      alignItems: 'center',
      justifyContent: 'center',
    },
    memberPickAvatarText: {
      fontSize: 11,
      fontWeight: '800',
      color: '#000',
    },
    memberPickName: {
      fontSize: 10,
      fontWeight: '600',
      color: C.inkDim,
      textAlign: 'center',
    },
    memberPickScore: {
      fontSize: 12,
      fontWeight: '800',
      color: C.ink,
      width: '100%',
      textAlign: 'center',
      paddingVertical: 3,
      borderRadius: 6,
      backgroundColor: C.panelHi,
    },
    memberPickExactBadge: {
      borderRadius: 4,
      paddingHorizontal: 5,
      paddingVertical: 1,
      backgroundColor: C.green,
    },
    memberPickExactBadgeText: {
      fontSize: 8,
      fontWeight: '800',
      color: '#000',
    },
  });
}
